<template>
  <!-- mobile race grid -->
  <div v-if="isMobile">
    <!--Render if data and form data is available-->
    <div v-if="Object.keys(detailedRace).length > 0">
      <v-simple-table>
        <thead class="primary">
        <tr>
          <th class="primaryTxt" style="text-align: left;">No.</th>
          <th class="primaryTxt" style="text-align: left;">Runner</th>
          <th class="primaryTxt" style="text-align: center;">Career</th>
          <!-- <th
            v-if="smallDisplay"
            class="primaryTxt"
            style="text-align: center;white-space:nowrap;"
            width="60"
          >Last 5</th> -->
          <th
            class="primaryTxt"
            style="text-align: right;white-space:nowrap;"
            width="60"
          >Odds</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="d in sortRunners(detailedRace.competitors)" :key="d.tabNo" @click="scrollToRunner(d.tabNo)">
          <!--                <a :href="`#`+d.tabNo" class="jockeyLink" style="color: white; width: 100%; height: 100%;"></a>-->
          <td width="60" style="padding: 0;text-align:left;">
            <span>
              <v-btn
                @click="scrollToRunner(d.tabNo)"
                outlined
                class="font-weight-bold ml-2 caption"
                fab
                x-small
                color="white"
                style="cursor:pointer;"
              >{{d.tabNo}}</v-btn>
            </span>
          </td>
          <td style="padding-left: 0; padding-right: 0; min-width: 160px" width="100%" v-if="!d.scratched">
            <img v-if="detailedRace.meeting.type === 'THOROUGHBRED' || detailedRace.meeting.type === 'HARNESS'" class="float-left mr-2 mt-1 ml-n3" :src="$silksUrl+'/'+gbsID+'_'+detailedRace.number+'_'+d.tabNo+'_64x64.png'" alt="jockey silks" height = "45">
            <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'GBR' && d.tabNo" class="float-left mr-2 mt-1 ml-n1" style="width:28px;margin-top:2px;overflow:hidden;" :class="['greyhoundSpriteUk-' + d.tabNo]" />
            <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'AUS' || detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'NZL' && d.tabNo" class="float-left mr-2 mt-1 ml-n1" style="width:28px;margin-top:2px;overflow:hidden;" :class="['greyhoundSpriteAUS-' + d.tabNo]" />
            <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'USA' || detailedRace.meeting.track.country === 'MEX' && d.tabNo" class="float-left mr-2 mt-1 ml-n1" style="width:28px;margin-top:2px;overflow:hidden;" :class="['greyhoundSpriteUs-' + d.tabNo]" />
            <div class="float-left">
              <div class="d-inline" style="max-width: 100px; text-overflow: ellipsis; white-space: nowrap; overflow:hidden; padding-right: 5px;font-size: 13px; font-weight: bold">{{d.name}}</div>
              <div class="d-inline" style="max-width: fit-content; padding-bottom: 2px; font-size: 13px">({{d.barrier}})</div>
            </div>
            <span
              class="float-left ml-1 red--text font-weight-black"
              style="font-size: 11px"
            >{{checkEmergencyIn(d.emergencyIndicator)}}</span>
            <br />
            <div class="float-left">
              <div v-if="!greyhoundMeeting(detailedRace)" style="white-space: nowrap; overflow: hidden; font-size: 11px;text-align:left">
                <div
                  v-if="!d.allowanceWeight"
                  class="float-left"
                  style="white-space: nowrap; overflow: hidden;max-width:80px;text-overflow: ellipsis;"
                >
                  <strong v-if="!harnessMeeting(detailedRace)">J:</strong>
                  <strong v-else>D:</strong>
                  {{d.jockey}}
                </div>
                <div
                  v-else
                  class="float-left"
                  style="white-space: nowrap; overflow: hidden;max-width:70px;text-overflow: ellipsis;"
                >
                  <strong>J:</strong>
                  {{d.jockey}}
                </div>
                <template v-if="!harnessMeeting(detailedRace)">
                  <div class="float-left ml-1" v-if="d.apprenticeIndicator">
                    <b>(a{{d.allowanceWeight}}/{{d.weightTotal}}kg)</b>
                  </div>
                  <div class="float-left ml-1" v-else-if="!d.apprenticeIndicator">
                    <b>({{d.weightTotal}}kg)</b>
                  </div>
                </template>
              </div>
              <div style="clear:both"></div>
              <div style="font-size: 11px;text-align:left">
                <div
                  class="float-left"
                  style="white-space: nowrap; overflow: hidden;"
                >
                  <strong>T:</strong>
                  {{d.trainer}}
                </div>
              </div>
            </div>
          </td>
          <td style="padding-left: 0; padding-right: 0; min-width: 160px" width="100%" v-else>
              <span>
                <img v-if="detailedRace.meeting.type === 'THOROUGHBRED' || detailedRace.meeting.type === 'HARNESS'" class="float-left mr-2 mt-1 ml-n3" :src="$silksUrl+'/'+gbsID+'_'+detailedRace.number+'_'+d.tabNo+'_64x64.png'" alt="jockey silks" height = "45">
                <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'GBR' && d.tabNo" class="float-left mr-2 mt-1 ml-n1" style="width:28px;margin-top:2px;overflow:hidden;" :class="['greyhoundSpriteUk-' + d.tabNo]" />
                <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'AUS' || detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'NZL' && d.tabNo" class="float-left mr-2 mt-1 ml-n1" style="width:28px;margin-top:2px;overflow:hidden;" :class="['greyhoundSpriteAUS-' + d.tabNo]" />
                <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'USA' || detailedRace.meeting.track.country === 'MEX' && d.tabNo" class="float-left mr-2 mt-1 ml-n1" style="width:28px;margin-top:2px;overflow:hidden;" :class="['greyhoundSpriteUs-' + d.tabNo]" />
              </span>
            <div>
              <div style="float:left;max-width: 100px; text-overflow: ellipsis; white-space: nowrap; overflow:hidden; padding-right: 5px;font-size: 13px; font-weight: bold; color: grey; text-decoration: line-through">{{d.name}}</div>
            </div>
            <br />
            <div class="float-left">
                <span
                  v-if="!greyhoundMeeting(detailedRace)"
                  class="float-left"
                  style="font-size: 11px; white-space: nowrap; overflow: hidden;text-decoration: line-through; color: grey"
                >
                  <strong>J:</strong>
                  {{d.jockey}}
                </span>
              <div style="clear:both"></div>
              <span
                class="float-left"
                style="font-size: 11px; white-space: nowrap; overflow: hidden;text-decoration: line-through; color: grey"
              >
                  <strong>T:</strong>
                  {{d.trainer}}
                </span>
            </div>
          </td>
          <td
            v-if="d.runnerStatistics && !d.scratched"
            width="100"
            style="white-space: nowrap;padding-left: 0; padding-right: 0; font-size: 12px"
          >
            <b>{{d.runnerStatistics.career.all.numberOfRuns}}:</b>
            {{d.runnerStatistics.career.all.firsts}}-{{d.runnerStatistics.career.all.seconds}}-{{d.runnerStatistics.career.all.thirds}}
          </td>
          <td
            v-else-if="d.runnerStatistics && d.scratched"
            style="text-decoration: line-through; color: grey; white-space: nowrap;font-size: 12px"
            width="100"
          >
            <b>{{d.runnerStatistics.career.all.numberOfRuns}}:</b>
            {{d.runnerStatistics.career.all.firsts}}-{{d.runnerStatistics.career.all.seconds}}-{{d.runnerStatistics.career.all.thirds}}
          </td>
          <td v-else-if="!d.runnerStatistics" style="white-space: nowrap;padding-left: 0; padding-right: 0;font-size: 12px">
            <b>0</b>: 0-0-0
          </td>
          <!-- <td width="60" style="padding-left: 0; padding-right: 0;font-size: 12px" v-if="!d.scratched && smallDisplay">{{checkFinalPos(d)}}</td>
          <td
            width="60"
            v-else-if="smallDisplay"
            style="text-decoration: line-through; color: grey; padding-left: 0; padding-right: 0;font-size: 12px"
          >{{checkFinalPos(d)}}</td> -->
          <td
            v-if="!d.scratched"
            width="60"
            style="text-align: right; padding-left: 0;font-size: 12px"
            class="font-weight-bold"
          >{{getRunnerFixedOdd(d.tabNo)}}</td>
          <td v-else width="60" style="text-align: right; padding-left: 0;font-size: 12px; color: grey;">Scratched</td>
        </tr>
        </tbody>
      </v-simple-table>
      <!--Render speedmap if it is available-->
      <template v-if="speedMapAvailable(detailedRace) && typeof featureToggle[bookie].speedMap === 'undefined'">
        <v-row justify="center" style="margin-left: 1%; margin-right: 1%">
          <v-expansion-panels v-model="panel" class="condensed mt-2">
            <v-expansion-panel>
              <v-expansion-panel-header class="primaryTxt font-weight-bold" height="30px">
                Speed Map
                <template v-slot:actions>
                  <v-icon class="primaryTxt">mdi-chevron-down</v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pt-3" color="grey lighten-3 speedMapBackLr">
                <div v-if="stateToRight(detailedRace.meeting.track.state)" class="text-left">
                  <h4 style="display: inline">Barrier</h4>
                  <h4 style="display: inline; float: right" class="text-right">Lead</h4>
                </div>
                <div v-if="stateToLeft(detailedRace.meeting.track.state)" class="text-right">
                  <h4 style="display: inline; float: left" class="text-left">Lead</h4>
                  <h4 style="display: inline">Barrier</h4>
                </div>
                <div v-else-if="!stateToLeft(detailedRace.meeting.track.state) && !stateToRight(detailedRace.meeting.track.state)" class="text-left">
                  <h4 style="display: inline">Barrier</h4>
                  <h4 style="display: inline; float: right" class="text-right">Lead</h4>
                </div>
                <v-progress-linear
                  v-if="stateToRight(detailedRace.meeting.track.state)"
                  :color="checkBookie(bookie)"
                  height="10"
                  rounded
                  class="mb-n3"
                ></v-progress-linear>
                <v-progress-linear
                  v-if="stateToLeft(detailedRace.meeting.track.state)"
                  reverse
                  :color="checkBookie(bookie)"
                  height="10"
                  rounded
                  class="mb-n3"
                ></v-progress-linear>
                <v-progress-linear
                  v-else-if="!stateToLeft(detailedRace.meeting.track.state) && !stateToRight(detailedRace.meeting.track.state)"
                  :color="checkBookie(bookie)"
                  height="10"
                  rounded
                  class="mb-n3"
                ></v-progress-linear>
                <br />
                <div
                  v-for="d in sortByBarrier(detailedRace.competitors)"
                  :key="d.tabNo"
                  style="margin-bottom: 10px"
                >
<!--                  <RunnerSpeedMapMobile :runner="d" :race="detailedRace" />-->
                  <NewSpeedMap :runner="d" :race="detailedRace" />
                  <div v-if="!d.scratched" style="height: 25px"></div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </template>
      <div v-else-if="detailedRace.meeting.type === 'GREYHOUND' || detailedRace.meeting.type === 'HARNESS'">
      </div>
      <!--Render if speedmap data is not available-->
      <!-- <div v-else>
        <br>
        <v-chip small label class="primaryTxt" color="primaryCol mt-n3">
          <div class="title font-weight-bold">
            <span>No Speedmap Data Available</span>
          </div>
        </v-chip>
      </div> -->
    </div>
  </div>
</template>

<script>
// import RunnerSpeedMapMobile from '../components/RunnerSpeedMapMobile'
// import RaceFieldDivs from '../components/RaceFieldDivs'
import { featureToggle } from '../common/config'
import { mapState, mapGetters } from 'vuex'
import NewSpeedMap from './NewSpeedMap'
export default {
  name: 'RaceField',
  components: {
    NewSpeedMap
    // RunnerSpeedMapMobile
    // RaceFieldDivs
  },
  props: {
    raceFlucs: Object,
    formAvailable: Boolean
  },
  data () {
    return {
      expansionOpen: false,
      panel: 0,
      featureToggle
    }
  },
  computed: {
    ...mapState(['bookie', 'raceNo', 'gbsID', 'detailedRace']),
    ...mapGetters(['isMobile', 'hasFeature']),
    smallDisplay () {
      return window.innerWidth >= 414
    }
  },
  methods: {
    harnessMeeting (data) {
      return data.meeting.type === 'HARNESS'
    },
    greyhoundMeeting (data) {
      return data.meeting.type === 'GREYHOUND'
    },
    speedMapAvailable (data) {
      let speedMapCount = 0
      // eslint-disable-next-line array-callback-return
      data.competitors.forEach((b) => {
        if (b.speedmapPosition) {
          speedMapCount += 1
        }
      })
      return speedMapCount !== 0
    },
    checkEmergencyIn (indicator) {
      if (indicator === true) {
        return 'E'
      } else {
        return ''
      }
    },
    sortRunners (data) {
      return data.slice().sort((a, b) => a.tabNo - b.tabNo)
    },
    getRunnerFixedOdd (tabNo) {
      let fixedPrice = 0
      this.raceFlucs.competitors.forEach(b => {
        // eslint-disable-next-line eqeqeq
        if (tabNo == b.tabNo) {
          // eslint-disable-next-line eqeqeq
          const newPrices = b.prices.filter(b => b.type == 'WIN_FIXED_ODDS')
          const flucs = newPrices.map(a => a.price)
          fixedPrice = flucs[flucs.length - 1] || 0
        }
      })
      return `$${fixedPrice.toFixed(2)}`
    },
    scrollToRunner (tabNo) {
      window.location.href = `#${tabNo}`
    },
    mutateDistance (distance, data) {
      let distanceObj = {
        firsts: 0,
        key: data,
        numberOfRuns: 0,
        seconds: 0,
        thirds: 0
      }
      distance?.forEach(b => {
        // eslint-disable-next-line eqeqeq
        if (b.key == data) {
          distanceObj = {
            firsts: b.firsts,
            key: b.key,
            numberOfRuns: b.numberOfRuns,
            seconds: b.seconds,
            thirds: b.thirds
          }
        }
      })
      return [distanceObj]
    },
    mutateTrack (track, data) {
      let trackObj = {
        firsts: 0,
        key: data,
        numberOfRuns: 0,
        seconds: 0,
        thirds: 0
      }
      track?.forEach(b => {
        if (b.key === data) {
          trackObj = {
            firsts: b.firsts,
            key: b.key,
            numberOfRuns: b.numberOfRuns,
            seconds: b.seconds,
            thirds: b.thirds
          }
        }
      })
      return [trackObj]
    },
    checkBookie (bookie) {
      switch (bookie) {
        case 'topsport':
          return 'light-blue'
        case 'betmakers':
          return 'pink'
        case 'uat':
          return 'pink'
        case 'neds':
          return 'orange'
        case 'do':
          return 'blue'
        case 'robwaterhouse':
          return 'purple'
        case 'realbookie':
          return 'cyan'
        case 'picnicbet':
          return 'blue darken-3'
        case 'bbet':
          return 'blue'
        case 'betdeluxe':
          return 'red'
        case 'crossbet':
          return 'cyan'
        case 'texbet':
          return 'green'
        case 'zbet':
          return 'blue'
        case 'nztab':
          return 'blue'
        case 'mailbag':
          return 'orange'
        case 'dimers':
          return 'blue'
        case 'pronet':
          return 'blue'
        case 'sportsbetting':
          return 'orange'
        case 'wishbet':
          return 'orange'
        case 'caymanasbet':
          return 'green'
        case 'betnation':
          return 'blue'
        case 'tomwaterhouse':
          return 'teal lighten-3'
        case 'getsetbet':
          return 'pink'
        case 'punt123':
          return 'blue'
        case 'marantelli':
          return 'red'
        case 'okebet':
          return 'blue'
        case 'betgold':
          return 'yellow'
        case 'monmouth':
          return 'green'
        case 'monmouthtech':
          return 'green'
        case 'bossbet':
          return 'blue'
        case 'readybet':
          return 'blue'
        case 'swiftbet':
          return 'blue'
        case 'baggybet':
          return 'orange'
        case 'upcoz':
          return 'orange'
        case 'mintbet':
          return 'green'
        case 'betr':
          return 'blue'
        case 'sportchamps':
          return 'blue'
        case 'foxcatcher':
          return 'green'
        case 'eskanderbet':
          return 'yellow'
        case 'diamondbet':
          return 'orange'
        case 'bitwinning':
          return 'orange'
        case 'thunderbet':
          return 'purple'
        case 'betestate':
          return 'yellow'
        case 'playwestbet':
          return 'blue'
        case 'chasebet':
          return 'purple'
        case 'premiumbet':
          return 'light-green'
        case 'bet66':
          return 'dark-blue'
        case 'betlocal':
          return 'purple'
      }
    },
    stateToRight (state) {
      switch (state) {
        case 'QLD':
          return true
        case 'NSW':
          return true
        case 'ACT':
          return true
      }
    },
    stateToLeft (state) {
      switch (state) {
        case 'VIC':
          return true
        case 'SA':
          return true
        case 'WA':
          return true
        case 'NT':
          return true
        case 'TAS':
          return true
      }
    },
    sortByBarrier (competitors) {
      return competitors.slice().sort((a, b) => b.barrier - a.barrier)
    },
    checkFinalPos (competitors) {
      const pastStartsFilter = competitors.formHistory.filter(e => e.class !== 'BTrial' && e.class !== 'Barrier Trial').filter((a) => a.starters > 0)
      const pastStarts = pastStartsFilter.slice(0, 5).reverse()
      const finalPos = pastStarts.map((b, index) => {
        if (index !== pastStarts.length - 1) {
          const nowTime = pastStarts[index].date
          const pastTimer = pastStarts[index + 1].date
          const nowTimeMili = new Date(nowTime).getTime()
          const pastTimeMili = new Date(pastTimer).getTime()
          const timeBetween = nowTimeMili - pastTimeMili
          const daysBetween = timeBetween / (1000 * 60 * 60 * 24)
          const daysFormatted = Math.floor(daysBetween)
          b.dslsLast5 = Math.abs(daysFormatted)
        }
        if (b.finishingPosition > 9) {
          return 0
        }
        if (b.dslsLast5 >= 84) {
          return b.finishingPosition + 'x'
        }
        return b.finishingPosition
      })
      const finalPosStr = finalPos.toString()
      const final = finalPosStr.replace(/,/g, '')
      return final
    }
  }
}
</script>

<style>
.v-progress-linear__determinate {
  border-radius: 10px;
}
.raceFieldContainer {
  max-width: 1024px;
  min-width: 1024px;
  box-shadow: 3px 5px 5px lightgrey;
}
.v-expansion-panels.condensed .v-expansion-panel-header {
  padding-top: 6px;
  padding-bottom: 6px;
  min-height: auto;
}
.v-expansion-panels.condensed
.v-expansion-panel--active
.v-expansion-panel-header {
  padding-top: 12px;
  padding-bottom: 12px;
}
.v-expansion-panels.condensed .v-expansion-panel--active:not(:first-child),
.v-expansion-panels.condensed .v-expansion-panel--active + .v-expansion-panel {
  margin-top: 4px;
}
.v-expansion-panel-content__wrap {
  padding: 5px;
}
</style>
